import React from "react";
import {
  VegaFlex,
  VegaDatePicker,
  VegaTimePicker,
  VegaButton,
} from "@heartlandone/vega-react";
import { VegaNotify } from "@heartlandone/vega";
import { useState, useEffect} from 'react';
import { getTodayDateString } from 'Chore/Utils';

const SECOND_STEP = 1;


function StepTwo ({currentStep, onPreviousClick = () => {}, onNextClick = () => {}, isEdit = false }) {
  const _isShow = () => currentStep === SECOND_STEP;
  const [registrationStartDate, setRegistrationStartDate] = useState('');
  const [registrationEndDate, setRegistrationEndDate] = useState('');
  const [activityStartDate, setActivityStartDate] = useState('');
  const [activityEndDate, setActivityEndDate] = useState('');
  const [registrationStartTime, setRegistrationStartTime] = useState('');
  const [registrationEndTime, setRegistrationEndTime] = useState('');
  const [activityStartTime, setActivityStartTime] = useState('');
  const [activityEndTime, setActivityEndTime] = useState('');

  const [canGoNext, setCanGoNext] = useState(false);

  useEffect(() => {
    setCanGoNext(
      registrationStartDate && registrationEndDate && activityStartDate && activityEndDate &&
      registrationStartTime && registrationEndTime && activityStartTime && activityEndTime
    );
  }, [registrationStartDate, registrationEndDate, activityStartDate, activityEndDate, registrationStartTime, registrationEndTime, activityStartTime, activityEndTime]);

  const _isValidDate = () => {
    const regStart = new Date(`${registrationStartDate} ${registrationStartTime}`);
    const regEnd = new Date(`${registrationEndDate} ${registrationEndTime}`);
    const actStart = new Date(`${activityStartDate} ${activityStartTime}`);
    const actEnd = new Date(`${activityEndDate} ${activityEndTime}`);
    return regStart < regEnd && actStart < actEnd && actStart >= regEnd;
  };

  const _onNextClick = async (stepName) => {
    if (_isValidDate()) {
      onNextClick(stepName);
      return;
    }
    await VegaNotify.open({
      type: 'error',
      duration: 5000,
      message: 'The dates are invalid. Please check the registration and activity dates and times.',
    });
  };

  return (
    <div className={`m-t-32${_isShow() ? "" : " display-none"}`} style={{ minWidth: 785}}>
      <VegaFlex direction="col" gap="size-48">
        <div className="form-step-title">Date & Time</div>
        <VegaFlex alignItems={`flex-start`} gap="size-16" justifyContent="space-between">
          <VegaFlex direction="row" gap="size-16" flex={1}>
            <VegaDatePicker
              style={{
                width: '55%',
              }}
              size="small"
              data-vega-form={"registerStartDate"}
              required={true}
              label="Registration Start Date"
              format="MM/DD/YYYY"
              disabled={isEdit}
              minDate={getTodayDateString()}
              onVegaChange= {(e)=>{
                setRegistrationStartDate(e.detail);
              }}
            />
            <VegaTimePicker
              size="small"
              style={{
                width: '50%',
              }}
              required={true}
              label="Start Time"
              increments={5}
              disabled={isEdit}
              data-vega-form={"registerStartTime"}
              onVegaChange={e=>{
                setRegistrationStartTime(e.detail);
              }}
            />
          </VegaFlex>
          <VegaFlex style={{marginTop: 40}}>
            to
          </VegaFlex>
          <VegaFlex direction="row" gap="size-16" flex={1}>
            <VegaDatePicker
              style={{
                width: '55%',
              }}
              required={true}
              size="small"
              data-vega-form={"registerEndDate"}
              label="Registration End Date"
              format="MM/DD/YYYY"
              disabled={isEdit}
              minDate={getTodayDateString()}
              onVegaChange= {(e)=>{
                setRegistrationEndDate(e.detail);
              }}
            />
            <VegaTimePicker
              size="small"
              style={{
                width: '50%',
              }}
              required={true}
              label="End Time"
              increments={5}
              disabled={isEdit}
              data-vega-form={"registerEndTime"}
              onVegaChange={e=>{
                setRegistrationEndTime(e.detail);
              }}
            />
          </VegaFlex>
        </VegaFlex>
        <VegaFlex alignItems={`flex-start`} gap="size-16" justifyContent="space-between">
          <VegaFlex direction="row" gap="size-16" flex={1}>
            <VegaDatePicker
              style={{
                width: '55%',
              }}
              size="small"
              data-vega-form={"activityStartDate"}
              required={true}
              minDate={getTodayDateString()}
              format="MM/DD/YYYY"
              label="Activity Start Date"
              onVegaChange= {(e)=>{
                setActivityStartDate(e.detail);
              }}
            />
            <VegaTimePicker
              size="small"
              style={{
                width: '50%',
              }}
              required={true}
              label="Start Time"
              increments={5}
              data-vega-form={"activityStartTime"}
              onVegaChange={e=>{
                setActivityStartTime(e.detail);
              }}
            />
          </VegaFlex>
          <VegaFlex style={{marginTop: 40}}>
            to
          </VegaFlex>
          <VegaFlex direction="row" gap="size-16" flex={1}>
            <VegaDatePicker
              style={{
                width: '55%',
              }}
              required={true}
              size="small"
              data-vega-form={"activityEndDate"}
              label="Activity End Date"
              format="MM/DD/YYYY"
              minDate={getTodayDateString()}
              onVegaChange= {(e)=>{
                setActivityEndDate(e.detail);
              }}
            />
            <VegaTimePicker
              size="small"
              style={{
                width: '50%',
              }}
              required={true}
              label="End Time"
              increments={5}
              data-vega-form={"activityEndTime"}
              onVegaChange={e=>{
                setActivityEndTime(e.detail);
              }}
            />
          </VegaFlex>
        </VegaFlex>
      </VegaFlex>
      <VegaFlex justifyContent='space-between' alignItem={'center'} className='m-t-40 p-t-20 p-b-48 border-none' style={{ marginBottom: -24 }}>
          <VegaButton variant="secondary" label = {"Previous"} onVegaClick={() => onPreviousClick('Date & Time')}/>
          <VegaButton label = {"Next"} disabled={!canGoNext} onVegaClick={() => _onNextClick('Date & Time')}/>
      </VegaFlex>
    </div>
  );
}

export default StepTwo;
